function _registerFilters(vueFactory) {
  vueFactory.filter('date1', (date) => {
    return date.toDateString()
  })

  vueFactory.filter('upper', (str) => {
    return str.toUpperCase()
  })
  vueFactory.filter('number', (n) => {
    return n.toLocaleString()
  })
  vueFactory.filter('price', (n) => {
    let dollars = n / 100;
    return dollars.toLocaleString("en-US", {style:"currency", currency:"USD"});
  })
  vueFactory.filter('currency', (dollars) => {
    return dollars.toLocaleString("en-US", {style:"currency", currency:"USD"});
  })
}

export const registerFilters = _registerFilters

